import { Component, OnInit } from "@angular/core";
import { AjaxService } from "src/app/service/ajax.service";
import { UtilService } from "src/app/service/util.service";
import { API } from "src/environments/environment";

interface AtividadeAtual {
  etapa?: string;
  modulo?: string;
  atividade?: string;
}

interface ParticipanteEtapaAtual {
  idDivisaoGrupo: number;
  grupo: string;
  nomeCrianca: string;
  nomeResponsavel: string;
  sexoCrianca: string;
  idTriagem: number;
  atividadeAtual?: AtividadeAtual;
}

interface Triagem {
  id: number;
  titulo: string;
}

@Component({
  selector: "app-participantes-etapa-atual",
  templateUrl: "./participantes-etapa-atual.component.html",
  styleUrls: ["./participantes-etapa-atual.component.scss"],
})
export class ParticipantesEtapaAtualComponent implements OnInit {
  participantes: ParticipanteEtapaAtual[] = [];
  filteredParticipantes: ParticipanteEtapaAtual[] = [];
  searchText = "";
  triagens: Triagem[] = [];
  selectedTriagem: number | null = null;

  constructor(private ajax: AjaxService, public util: UtilService) {}

  ngOnInit(): void {
    this.carregarTriagens();
  }

  carregarTriagens(): void {
    this.util.showLoading();
    const url = API + "Triagem/Triagem?TIPO=T";
    this.ajax.get(url).subscribe(
      (response) => {
        const lista = response?.data || [];
        this.triagens = lista
          .map((item: any) => ({
            id: item?.iD_TRIAGEM ?? item?.ID_TRIAGEM ?? item?.idTriagem ?? item?.id,
            titulo: item?.titulo ?? item?.TITULO ?? "Sem título",
          }))
          .filter((item: Triagem) => !!item.id);

        if (this.triagens.length > 0) {
          this.selectedTriagem = this.triagens[0].id;
          this.buscarParticipantes();
        } else {
          this.participantes = [];
          this.filteredParticipantes = [];
        }
        this.util.closeLoading();
      },
      () => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao carregar triagens");
      }
    );
  }

  buscarParticipantes(): void {
    if (!this.selectedTriagem) {
      this.participantes = [];
      this.filteredParticipantes = [];
      return;
    }

    this.util.showLoading();
    const url =
      API +
      "DivisaoGrupo/DivisaoGrupo/BuscarParticipantesEtapaAtual/" +
      this.selectedTriagem;

    this.ajax.get(url).subscribe(
      (response) => {
        const data = response.data || [];
        this.participantes = data.map((item: any) => this.mapParticipante(item));
        this.filteredParticipantes = [...this.participantes];
        this.util.closeLoading();
      },
      () => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao carregar participantes");
      }
    );
  }

  onTriagemChange(): void {
    this.buscarParticipantes();
  }

  /**
   * Exporta Excel com respostas do programa (apenas participantes em divisao_grupo).
   * GET api/QuerParticipar/QuerParticipar/exportarRespostasPrograma/{ID_TRIAGEM}
   */
  exportarRespostasPrograma(): void {
    if (!this.selectedTriagem) {
      this.util.toasterShowWarning(
        "Atenção",
        "Selecione o programa para exportar as respostas"
      );
      return;
    }
    this.util.showLoading();
    const url =
      API +
      "QuerParticipar/QuerParticipar/exportarRespostasPrograma/" +
      this.selectedTriagem;
    window.open(url);
    this.util.closeLoading();
  }

  onSearch(): void {
    const termo = (this.searchText || "").toLowerCase().trim();
    if (!termo) {
      this.filteredParticipantes = [...this.participantes];
      return;
    }

    this.filteredParticipantes = this.participantes.filter((item) =>
      [item.nomeResponsavel, item.nomeCrianca, item.grupo, item.atividadeAtual?.etapa, item.atividadeAtual?.modulo, item.atividadeAtual?.atividade]
        .filter(Boolean)
        .some((texto) => (texto as string).toLowerCase().includes(termo))
    );
  }

  private mapParticipante(item: any): ParticipanteEtapaAtual {
    return {
      idDivisaoGrupo: item.iD_DIVISAO_GRUPO,
      grupo: this.formatarGrupo(item.grupo),
      nomeCrianca: item.criancA_NOME,
      nomeResponsavel: item.reponsaveL_NOME || item.responsaveL_NOME,
      sexoCrianca: item.criancA_SEXO,
      idTriagem: item.iD_TRIAGEM,
      atividadeAtual: {
        etapa: item.atividadeCurrence?.etapa,
        modulo: item.atividadeCurrence?.modulo,
        atividade: item.atividadeCurrence?.atividade,
      },
    };
  }

  private formatarGrupo(grupo: string): string {
    const valor = (grupo || "").toUpperCase().trim();
    if (valor === "I") {
      return "Intervenção";
    }
    if (valor === "C") {
      return "Controle";
    }
    return grupo || "-";
  }

  getGrupoCssClass(grupo: string): string {
    const valor = (grupo || "").toLowerCase().trim();
    if (valor === "intervenção" || valor === "intervencao") {
      return "grupo-intervencao";
    }
    if (valor === "controle") {
      return "grupo-controle";
    }
    return "grupo-neutro";
  }
}
